import React from 'react';

export const RankingTabs = ({ tabs, activeTab, onTabChange, tabLabels }) => {
  const renderLabel = (tab) => {
    return tabLabels[tab] || tab;
  };

  return (
    <div className="border-b border-[var(--theme-border)]">
      <div className="flex items-center w-full overflow-x-auto scrollbar-hide whitespace-nowrap pt-0.5">
        {tabs.map((tab) => {
          const isActive = tab === activeTab;
          return (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={`
                flex-shrink-0 px-6 py-3 font-medium text-sm transition-all duration-200
                border-b-2 hover:text-[var(--theme-primary)] dark:hover:text-[var(--theme-primary)]
                ${
                  isActive
                    ? 'border-[var(--theme-primary)] text-[var(--theme-primary)] dark:border-[var(--theme-primary)] dark:text-[var(--theme-primary)] font-semibold'
                    : 'border-transparent text-[var(--theme-text)] dark:text-[var(--theme-text)]'
                }
              `}
            >
              {renderLabel(tab)}
            </button>
          );
        })}
      </div>
    </div>
  );
};
